import { createFileRoute } from '@tanstack/react-router'
import PageEntrance from '~components/motion/page-entrance'
import MyConsultations from '~containers/app/my-consultations'
import { State } from '~models/consultation/types'
import useMyConsultations from '~repositories/hooks/use-my-consultations'

export const Route = createFileRoute('/samsung/smart-things/(app)/my-consultations/')({
  component: RouteComponent,
})

function RouteComponent() {
  useMyConsultations({
    states: [State.Pending, State.Occupied, State.Answered, State.Additional, State.Closed],
  })

  return (
    <PageEntrance>
      <MyConsultations />
    </PageEntrance>
  )
}
